import styled, { css } from 'styled-components';
import { accent, gray, primary, white } from '~/components/mixins/color';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  .main {
    display: flex;
    flex-direction: column;
    width: calc(100% - 60px);
    height: 100%;
    background: linear-gradient(135deg, ${accent.fade(0.97).string()}, ${accent.fade(0.93).string()});
  }
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 60px);
`;

export const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;

  & > div {
    margin-left: 10px;
  }
`;

export const IconButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  margin: 5px 0px 5px 5px;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 3px;
  font-size: 14px;

  background: ${primary.hex()};
  border: 2px solid ${primary.hex()};
  color: ${gray.hex()};

  &:hover:enabled,
  &:focus:enabled {
    color: ${white.hex()};
    background: ${accent.hex()};
  }
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.2;
      cursor: not-allowed;
      user-select: none;
      font-weight: normal;
    `}
  }
`;
